import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../api/axios";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // STEP 1: SEND OTP
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({});

    try {
      const res = await API.post("/forgotPassword", {
        user_email: email,
      });

      setMessage({ type: "success", text: res.data.message });
      setStep(2);
    } catch (err) {
      setMessage({
        type: "danger",
        text: err.response?.data?.message || "Failed to send OTP",
      });
    } finally {
      setLoading(false);
    }
  };

  // STEP 2: VERIFY OTP + RESET PASSWORD (SINGLE API)
  const handleVerifyOtpAndReset = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage({
        type: "danger",
        text: "Passwords do not match",
      });
      return;
    }
    setLoading(true);
    setMessage({});

    try {
      const res = await API.post("/verifyOtpAndResetPassword", {
        user_email: email,
        otp,
        newPassword,
      });

      setMessage({
        type: "success",
        text: res.data.message || "Password reset successful",
      });

      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setMessage({
        type: "danger",
        text:
          err.response?.data?.error ||
          err.response?.data?.message ||
          "Invalid OTP or OTP expired",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-form-bg h-100">
      <div className="container h-100">
        <div className="row justify-content-center h-100">
          <div className="col-xl-6">
            <div className="card login-card">
              <div className="card-body pt-5">

                <img
                  src="/assets/img/logo-preview.png"
                  alt="Logo"
                  className="d-block mx-auto mb-3"
                />

                {message.text && (
                  <div className={`alert alert-${message.type}`}>
                    {message.text}
                  </div>
                )}

                {/* STEP 1: EMAIL */}
                {step === 1 && (
                  <form onSubmit={handleSendOtp}>
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Registered Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <span
                            className="input-group-text"
                          >
                          <i class="fa fa-solid fa-at"></i>
                      </span>
                    </div>
                    <button
                      className="mt-3 btn btn-primary w-100"
                      disabled={loading}
                    >
                      {loading ? "Sending OTP..." : "Send OTP"}
                    </button>
                  </form>
                )}

                {/* STEP 2: OTP + NEW PASSWORD */}
                {step === 2 && (
                  <form onSubmit={handleVerifyOtpAndReset}>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                      />
                      <span
                            className="input-group-text"
                          >
                          <i class="fa fa-solid fa-lock"></i>

                      </span>
                    </div>
                    <div className="mt-3 input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                      <span
                            className="input-group-text"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer" }}
                          >
                          <i
                            className={`fa fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                          />
                      </span>
                    </div>
                    <div className="mt-3 input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      <span
                            className="input-group-text"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer" }}
                          >
                          <i
                            className={`fa fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                          />
                      </span>
                    </div>
                    {confirmPassword && newPassword !== confirmPassword && (
                      <small className="text-danger d-block mt-1">
                        Passwords do not match
                      </small>
                    )}
                    <button
                      className="mt-4 btn btn-primary w-100"
                      disabled={loading || newPassword !== confirmPassword}
                    >
                      {loading ? "Resetting..." : "Verify OTP & Reset Password"}
                    </button>
                  </form>
                )}

                <p className="mt-4 text-center">
                  <Link to="/" className="text-primary">
                    Back to Login
                  </Link>
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
